export class ProductForm extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))

    this.listeners.add(
      this.form,
      'change',
      this.onSelectChangeHandler.bind(this),
    )
  }

  onSelectChangeHandler (e) {
    // if select element with data attribute 'data-setbuilder-preorder-select'
    if (e.target.hasAttribute('data-setbuilder-preorder-select')) {
      const selectedValue = e.target.value

      const submitButton = this.form.querySelector('button[type="submit"]')
      if (submitButton) {
        submitButton.setAttribute('data-variant-id', selectedValue)

        const productUrl = submitButton.getAttribute('data-product-url')
        const newProductUrl = `${
          productUrl.split('?variant=')[0]
        }?variant=${selectedValue}`
        submitButton.setAttribute('data-product-url', newProductUrl)
      }
    }
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    await this.addToCart()
  }

  async addToCart () {
    return window.BAO.Cart.addItemFromForm(this.form)
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
